import Request from '@request/Request';

export default class extends Request {
  constructor(validationObserver, data = {}) {
    data = {
      first_name: '',
      last_name: '',
      password: '',
      password_confirmation: '',
      email: '',
      phone_number: '',
      is_tourist: false,
      business: {
        name: '',
        website: '',
        location: {
          lat: '',
          lng: '',
          name: '',
        },
        trip_ids: [],
      },
      country_code: '',
      years_of_diving: '',
      no_of_dives: '',
      ...data,
    };
    super(validationObserver, data);
    this.$validator = validationObserver;
  }

  async submit() {
    this.beforeSubmit();

    try {
      const payload = this.data();
      if (payload.is_tourist) {
        delete payload.business;
      }
      let response = await this.postPromise('/users/register', payload);
      $showSuccess(response.message, 'registration-toast');
      window.$registered = true;
      $router.push({
        name: 'email-confirmation',
        query: {
          email: this.email,
        },
      });
      this.reset();
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }

  async testValidation($validator) {
    this.beforeSubmit();
    try {
      let data = this.data();
      data.persist = null;
      delete data.business;
      return await this.postPromise('/users/register', data);
    } catch (error) {
      if (error.response?.status === 422) {
        let validationErrors = error.response.data.errors;
        delete validationErrors.persist;
        validationErrors = this.handleFields(validationErrors);
        await this.handleValidation(validationErrors);
        let flag = true;
        for (let field in validationErrors) {
          if ($validator.fields[field] && validationErrors[field].length) {
            flag = false;
            break;
          }
        }
        return flag;
      }
    } finally {
      this.afterSubmit();
    }
  }
}
